import { useEffect, useState } from 'react';

import GoogleAddressSelect from './google/GoogleAddressSelect';

import { getFirestoreValue } from '../../../utils/firestore/tools';
import { AdaptiveModal } from '../AdaptiveModal';

export const AddressSelectModal = ({ open, onOpen }) => {
  const [googleApiKey, setGoogleApiKey] = useState('');

  useEffect(() => {
    const fetchApiKey = async () => {
      const key = await getFirestoreValue('google_api_key');
      setGoogleApiKey(key);
    };
    fetchApiKey();
  }, []);

  return (
    <AdaptiveModal
      open={open}
      onOpen={onOpen}
      contentStyle={{
        width: '450px',
        overflow: 'hidden',
        height: '90%',
        maxHeight: '820px'
      }}
    >
      {googleApiKey && (
        <GoogleAddressSelect onCancel={() => onOpen(false)} googleApiKey={googleApiKey} />
      )}
    </AdaptiveModal>
  );
};
